import { render, staticRenderFns } from "./AppButtonDelete.vue?vue&type=template&id=ab2753f0"
import script from "./AppButtonDelete.vue?vue&type=script&lang=js"
export * from "./AppButtonDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports